import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '../Button/Button';

import styles from './ToastBody.module.scss';

const ToastBody = (props) => {

  const {
    className,
    buttonClassName, buttonTitle, buttonOnClick, buttonLoading,
    message, messageClassName,
  } = props;

  return (
    <div className={classnames(styles.root, className)}>
      {
        message && (
          <div className={classnames(styles.message, messageClassName)}>
            {message}
          </div>
        )
      }
      {
        buttonTitle && (
          <Button
            size="small"
            type="button"
            className={classnames(styles.button, buttonClassName)}
            onClick={buttonOnClick}
            loading={buttonLoading}
          >
            {buttonTitle}
          </Button>
        )
      }
    </div>
  );
};

ToastBody.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  messageClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  buttonClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  message: PropTypes.node,
  buttonTitle: PropTypes.string,
  buttonOnClick: PropTypes.func
};

export default ToastBody;
